export const DEPOSIT = "DEPOSIT";

export const CHEQUE = "CHEQUE";

export const VERSO = "VERSO";

export const RECTO = "RECTO";
